// analyticsSidebar.js
import React, { useState, useEffect } from 'react';
import './analyticsSidebar.css'; // Sidebar CSS
import logo from './logo.webp'; // Import logo

const AnalyticsSidebar = ({ onSelect, selectedOption }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    let timer;
    const handleMouseEnter = () => {
      timer = setTimeout(() => setIsExpanded(true), 1000); // Expand after 1 second
    };

    const handleMouseLeave = () => {
      clearTimeout(timer); // Clear timer if mouse leaves early
      setIsExpanded(false);
    };

    const sidebar = document.querySelector('.analytics-sidebar');
    sidebar.addEventListener('mouseenter', handleMouseEnter);
    sidebar.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      sidebar.removeEventListener('mouseenter', handleMouseEnter);
      sidebar.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  const sidebarItems = [
    { label: 'Key Metrics', icon: '📊', value: 'key-metrics' },
    { label: 'Top Themes', icon: '🎯', value: 'top-themes' },
    { label: 'Influencers', icon: '🌟', value: 'influencers' },
    { label: 'Demographics', icon: '👥', value: 'demographics' },
    { label: 'World Map', icon: '🗺️', value: 'world-map' },
    { label: 'Results', icon: '📈', value: 'results' },
  ];

  return (
    <div className={`analytics-sidebar ${isExpanded ? 'expanded' : ''}`}>
      <div className="sidebar-logo">
        <img src={logo} alt="Analytics Logo" className="analytics-logo" />
      </div>

      <ul>
        {sidebarItems.map((item) => (
          <li
            key={item.value}
            onClick={() => onSelect(item.value)}
            className={selectedOption === item.value ? 'active' : ''}
          >
            {item.icon} <span className="sidebar-text">{item.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AnalyticsSidebar;
